import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Spinner from 'shopper/components/Spinner';
import { TabNav, TabNavItem } from 'shopper/components/TabNav';

import { sendEvent } from 'lib/gtag';

const TABS = [
  {
    name: 'Semanal',
    days: 7,
    gaEventActionId: 'this_week',
  },
  {
    name: 'Mensal',
    days: 30,
    gaEventActionId: 'this_month',
  },
];

const TopContributorsRanking = forwardRef(
  (
    {
      children,
      className,
      daysRange,
      gaEventCategory = null,
      isLoading = false,
      title,
      onChangeDaysRange,
      ...rest
    },
    ref
  ) => {
    const onTabNavItemClick = ({ days, gaEventActionId }) => {
      onChangeDaysRange(days);

      if (gaEventCategory) {
        sendEvent({ category: gaEventCategory, action: gaEventActionId });
      }
    };

    return (
      <Box ref={ref} className={twMerge('p-4', className)} {...rest}>
        <Heading as="span" className="mb-2" size="size5">
          {title}
        </Heading>
        <div>
          <TabNav size="size2">
            {TABS.map(({ name, days, gaEventActionId }) => (
              <TabNavItem
                key={name}
                active={daysRange === days}
                className="w-1/2"
                size="size2"
                onClick={() => onTabNavItemClick({ days, gaEventActionId })}
              >
                {name}
              </TabNavItem>
            ))}
          </TabNav>
          <div className="mt-2">
            {isLoading ? (
              <div className="flex h-80 items-center justify-center">
                <Spinner />
              </div>
            ) : (
              children
            )}
          </div>
        </div>
      </Box>
    );
  }
);

TopContributorsRanking.displayName = 'TopContributorsRanking';

TopContributorsRanking.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  daysRange: PropTypes.number.isRequired,
  gaEventCategory: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onChangeDaysRange: PropTypes.func.isRequired,
};

export default TopContributorsRanking;
